import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip,
    Link
} from "@mui/material";
import moment from "moment";
import { RxCross2 } from "react-icons/rx";
import StatusBadge from "components/badge/StatusBadge";

const ViewCam = (props) => {
    const { open, handleClose, rowData, isLoading } = props;

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        mb: 0.5,
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mb: 2,
    };

    const getAvatarColor = (text) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = text ? text.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View CAM Details
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: "3px",
                        border: "1px solid #e5e7eb",
                        backgroundColor: "#fff",
                        p: 2,
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 1,
                        }}
                    >
                        <Typography sx={{
                            fontWeight: 600,
                            fontSize: "20px",
                            fontFamily: "Outfit, sans-serif",
                            color: "#0A0A0C"
                        }}>
                            CAM Information
                        </Typography>
                    </Box>

                    <Divider sx={{ mb: 3 }} />

                    <CardContent sx={{ pt: 0 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12 }}>
                                <Grid container spacing={1}>
                                    {/* <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>ID:</strong>
                                        </Typography>
                                        <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2, p: 0 }}>
                                            <Avatar
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    bgcolor: getAvatarColor(rowData?.customId || ""),
                                                    color: "#fff",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                    p: 0,
                                                    m: 0
                                                }}
                                            >
                                                {rowData?.customId?.[0] || "I"}
                                            </Avatar>
                                            <Typography sx={valueStyle}>
                                                {rowData?.customId ?? "N/A"}
                                            </Typography>
                                        </Box>
                                    </Grid> */}

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Product:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.product ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Project:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.project ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Period:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.period ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Project CAM Revenue (INR per sqft):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.camRevenue ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Project CAM Cost/Expense (INR per sqft):</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.camCost ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>Margin:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.margin ?? "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <Typography sx={labelStyle}>
                                            <strong>% Margin:</strong>
                                        </Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.marginPercentage ?? "N/A"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
        </Dialog>
    );
};

export default ViewCam;